import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../shared';
import { SharedUiModule } from '../shared-ui';

import { GatewayCommissioningGuardService } from './gateway-commissioning.guard.service';
import { GatewayCommissioningRouting } from './gateway-commissioning.routing';
import { CheckLightComponent } from './gateway-commissioning/check-light/check-light.component';
import { GatewayCommissioningComponent } from './gateway-commissioning/gateway-commissioning.component';
import { TransferInstallationComponent } from './gateway-commissioning/transfer-installation/transfer-installation.component';
import { TransferSuccessComponent } from './gateway-commissioning/transfer-success/transfer-success.component';
import { HeatingTypeFormComponent } from './gateway-commissioning/transfer-installation/heating-type-form/heating-type-form.component';
import { InstallationTypeSelectComponent } from './gateway-commissioning/installation-type-select/installation-type-select.component';
import { CommissioningStepsComponent } from './gateway-commissioning/commissioning-steps/commissioning-steps.component';
import { EditCommissioningStepComponent } from './gateway-commissioning/edit-commissioning-step/edit-commissioning-step.component';
import { OneBaseInstructionsComponent } from './gateway-commissioning/one-base-instructions/one-base-instructions.component';
import { VitoconnectInstructionsComponent } from './gateway-commissioning/vitoconnect-instructions/vitoconnect-instructions.component';
import { GatewayFormComponent } from './gateway-commissioning/transfer-installation/gateway-form/gateway-form.component';
import { AddressFormComponent } from './gateway-commissioning/transfer-installation/address-form/address-form.component';
import { OmaFunctionFormComponent } from './gateway-commissioning/transfer-installation/oma-function-form/oma-function-form.component';
import { OwnerAdministratorFormComponent } from './gateway-commissioning/transfer-installation/owner-administrator-form/owner-administrator-form.component';
import { DescriptionFormComponent } from './gateway-commissioning/transfer-installation/description-form/description-form.component';
import { ViDswFooterComponent } from '../shared/+design-system-web/vi-dsw-footer/vi-dsw-footer.component';

@NgModule({
  declarations: [
    GatewayCommissioningComponent,
    TransferInstallationComponent,
    CheckLightComponent,
    TransferSuccessComponent,
    HeatingTypeFormComponent,
    InstallationTypeSelectComponent,
    CommissioningStepsComponent,
    EditCommissioningStepComponent,
    OneBaseInstructionsComponent,
    VitoconnectInstructionsComponent,
    GatewayFormComponent,
    AddressFormComponent,
    OmaFunctionFormComponent,
    OwnerAdministratorFormComponent,
    DescriptionFormComponent,
  ],
  providers: [GatewayCommissioningGuardService],
  imports: [
    SharedDependenciesModule,
    SharedUiModule,
    GatewayCommissioningRouting,
    ViDswFooterComponent,
  ],
})
export class GatewayCommissioningModule {}
